import React, { useEffect, useState } from "react";
import "../assets/SalaryReport.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { getBranches } from "../redux/slices/branchSlice";

const SalaryReport = () => {
  const dispatch = useDispatch();
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedData, setSelecteddata] = useState([]);

  const { list: data } = useSelector((state) => state.employeeReport);
  const pageSize = 1000;
  const superAdminId = localStorage.getItem("adminuserId") || "14";

  const fetchData = (page = 1) => {
    dispatch(fetchEmployeeReport({ page, pageSize }));
    dispatch(getBranches({ page, pageSize }));
  };

  const { branches } = useSelector((state) => state.branch);

  useEffect(() => {
    fetchData(1);
  }, []);

  const getSalaryStructures = async () => {
    try {
      const params = { superAdminId };

      if (selectedBranch) params.branchId = selectedBranch;
      if (selectedEmployee) params.employeeId = selectedEmployee;

      const response = await axios.get(
        "https://payyug.in/api/salary-structures",
        { params }
      );

      setSelecteddata(response.data.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching salary structures:", error);
      throw error;
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://payyug.in/api/salary-structures/${id}`
      );

      setSelecteddata((prev) =>
        prev.filter((item) => item.id !== id)
      );

      alert("Deleted successfully");
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete record");
    }
  };

  return (
    <div className="CalculateSalary-container">
      <h1 className="CalculateSalary-title">Salary Report</h1>

      {/* Filters */}
      <div className="SalaryReport-filterSection">
        <div className="SalaryReport-filter-wrappper">
          <div className="SalaryReport-field">
            <label>Select Branch *</label>
            <select
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
            >
              <option value="">Select Branch</option>
              {branches.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.name}- {emp.id}
                </option>
              ))}
            </select>
          </div>

          <div className="SalaryReport-field">
            <label>Select Employee*</label>
            <select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
            >
              <option value="">Select Employee</option>
              {data.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.fullName}- {emp.id}
                </option>
              ))}
            </select>
          </div>
        </div>

        <button
          className="salaryreport-filter"
          onClick={getSalaryStructures}
        >
          Filter
        </button>
      </div>

      {/* Table */}
      <div className="CalculateSalary-tableWrapper">
        <table className="CalculateSalary-table">
          <thead>
            <tr>
              <th>S.N.</th>
              <th>Employee Name</th>
              <th>Employee Id</th>
              <th>Salary Month</th>
              <th>Working Days</th>
              <th>Fuel Allowance (₹)</th>
              <th>Commission (₹)</th>
              <th>HRA (₹)</th>
              <th>Basic Salary (₹)</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {selectedData.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            ) : (
              selectedData.map((emp, index) => (
                <tr key={emp.id}>
                  <td>{index + 1}</td>
                  <td>{emp.employee.fullName || "N/A"}</td>
                  <td>{emp.employee.userId || "N/A"}</td>
                  <td>{emp.salaryMonth || "N/A"}</td>
                  <td>{emp.workingDays || "N/A"}</td>
                  <td>{emp.fuelAllowance || "N/A"}</td>
                  <td>{emp.commission || "N/A"}</td>
                  <td>{emp.hra || "N/A"}</td>
                  <td>{`₹${emp.totalSalary}` || "N/A"}</td>

                  {/* Added delete button */}
                  <td>
                    <button
                      onClick={() => handleDelete(emp.id)}
                      style={{
                        width: "28px",
                        height: "28px",
                        background: "#e74c3c",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px"
                      }}
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalaryReport;